import BaseAPI from './base-api-client.js'
import { fetchResponseHandler } from './error-utils.js'

export default class CurrencyAPI extends BaseAPI {
    static async getCurrencies () {
        try {
            const response = await this.fetch('/currency', {
                method: 'GET',
            })

            return await fetchResponseHandler(response)
        } catch (error) {
            console.error('Error fetching supported currencies:', error)
            throw error
        }
    }
}
